import DefaultSelect from '@hero/ui-kit/inputs/DefaultSelect';
import Form from '@hero/ui-kit/inputs/Form';
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { noop } from 'ts-essentials';
import * as yup from 'yup';

export const NotOutreachedSchema = yup
    .object()
    .shape({
        not_outreached: yup.string().nullable()
    })
    .defined();

export type NotOutreachedSchemaParams = yup.InferType<typeof NotOutreachedSchema>;

const NotOutreachedFilter: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    return (
        <Form
            validationSchema={NotOutreachedSchema}
            submitFn={noop}
            defaultValues={{
                not_outreached: searchParams.get('not_outreached') ? 'true' : 'false'
            }}
        >
            <DefaultSelect
                styles={{ minWidth: '205px' }}
                name="not_outreached"
                onChange={(e) => {
                    const value = e.currentTarget.value;

                    setSearchParams((prevState) => {
                        if (value === 'false') {
                            prevState.delete('not_outreached');
                        } else {
                            prevState.set('not_outreached', value);
                        }

                        return prevState;
                    });
                }}
                options={[
                    { label: 'All', value: 'false' },
                    { label: 'Not Outreached', value: 'true' }
                ]}
            />
        </Form>
    );
};

export default NotOutreachedFilter;
